import { all } from "redux-saga/effects";
import { watchAuthAsync } from "./authentication";

export function* rootSaga() {
  yield all([watchAuthAsync()]);
}
